import api from "@/plugins/api/EntryPoint";

export default {
  async createDistributionOrderKyiv(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-kyiv/create-distribution-order-kyiv",
      params,
      callBackFn
    );
  },
  async createDistributionToOrderKyiv(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-kyiv/create-distribution-to-order-kyiv",
      params,
      callBackFn
    );
  },
  async getKyivAccountDistributionDebt(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-kyiv/get-kyiv-account-distribution-debt",
      params,
      callBackFn
    );
  },
};
